import * as React from "react"
import IconSkeleton from "./IconSkeleton"
import { IconProps } from "./types"

export default function GitLabIcon(props: IconProps) {
  return (
    <IconSkeleton {...props} iconName="GitLabIcon" fill="none" stroke="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.089 21.5871L15.8043 10.1526H8.37366L12.089 21.5871Z"
        fill="#E24329"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0889 21.5871L8.3736 10.1526H3.16669L12.0889 21.5871Z"
        fill="#FC6D26"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16672 10.1526L2.0377 13.6274C1.93473 13.9443 2.04751 14.2915 2.31712 14.4874L12.0889 21.5871L3.16672 10.1526Z"
        fill="#FCA326"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16669 10.1527H8.3736L6.13586 3.26578C6.02076 2.91136 5.51943 2.91146 5.40433 3.26578L3.16669 10.1527Z"
        fill="#E24329"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0889 21.5871L15.8042 10.1526H21.0111L12.0889 21.5871Z"
        fill="#FC6D26"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0111 10.1526L22.1402 13.6274C22.2431 13.9443 22.1304 14.2915 21.8607 14.4874L12.0889 21.5871L21.0111 10.1526Z"
        fill="#FCA326"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0112 10.1527H15.8043L18.042 3.26578C18.1571 2.91136 18.6584 2.91146 18.7735 3.26578L21.0112 10.1527Z"
        fill="#E24329"
      />
    </IconSkeleton>
  )
}
